import React from "react";
import "./PreviewClubCard.css";
import {
  CalendarIcon,
  ClockIcon,
  DefaultClubLogo,
} from "../../../../../utils/icons";

const PreviewClubCard = ({ primaryHex, secondaryHex, mapIndex }) => {
  return (
    <div
      className="preview-club-card-container"
      style={
        mapIndex % 2 === 0
          ? {
              background: `linear-gradient(to bottom, ${primaryHex}, ${secondaryHex})`,
            }
          : {
              background: `linear-gradient(to bottom, ${secondaryHex}, ${primaryHex})`,
            }
      }
    >
      <div className="preview-club-card">
        <div className="preview-club-card-team-tag">
          {mapIndex % 2 === 0 ? "A" : "H"}
        </div>
        <div className="preview-club-card-content">
          <div
            style={{
              color: "white",
              display: "flex",
              justifyContent: "center",
              marginBottom: "12px",
            }}
          >
            <img
              src={DefaultClubLogo}
              alt="club-logo"
              style={{ height: "42px", width: "42px" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "4px",
              marginRight: "4px",
              paddingLeft: "10px",
            }}
          >
            <div className="preview-club-card-center">
              <img
                src={CalendarIcon}
                alt="club-logo"
                style={{ height: "14px", width: "14px" }}
              />
            </div>

            <div style={{ textAlign: "center" }}>
              <p style={{ fontSize: "12px" }}>Dec 23</p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "4px",
              marginRight: "4px",
              paddingLeft: "10px",
              marginTop: "2px",
            }}
          >
            <div className="preview-club-card-center">
              <img
                src={ClockIcon}
                alt="club-logo"
                style={{ height: "14px", width: "14px" }}
              />
            </div>

            <div style={{ textAlign: "center" }}>
              <p style={{ fontSize: "12px" }}>09:00 PM</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewClubCard;
